export default {
  nav: { home: "Início", treatments: "Tratamentos", about: "Sobre mim", studio: "Estúdio", contact: "Contato" },
  cta: {
    book: "Agendar horário",
    discover: "Descobrir tratamentos",
    moreAbout: "Mais sobre mim",
    allTreatments: "Todos os tratamentos",
    send: "Enviar pedido",
    sending: "Enviando…",
    call: "Ligar agora",
    whatsapp: "Escrever pelo WhatsApp",
    backHome: "Voltar ao início",
    discoverStudio: "Conhecer o estúdio",
    request: "Solicitar agendamento",
    readMore: "Saiba mais",
  },
  header: { openMenu: "Abrir menu", closeMenu: "Fechar menu", languageLabel: "Escolher idioma" },
  home: {
    heroEyebrow: "Beauty & Wellness · Basileia",
    heroLines: ["Beleza.", "Relaxamento.", "Bem-estar."],
    heroWelcomePre: "Bem-vinda à",
    heroWelcomeBrand: "IMPERIUM.",
    heroSub: "Cosmética profissional e massagens relaxantes para mais luminosidade, calma e bem-estar.",
    heroQuote: "“Atendimento pessoal, tratamentos de alta qualidade e um ambiente em que você pode ser completamente você mesma.”",
    trustNo: "01",
    trustEyebrow: "Confiança",
    trustTitle: "A beleza começa com confiança.",
    trustText: "Sua pele, seu corpo e seu bem-estar merecem atenção. Na IMPERIUM se encontram tratamento profissional, atendimento pessoal e um ambiente em que você pode se sentir completamente à vontade.",
    trustPoints: ["Atendimento pessoal", "Tratamento individual", "Ambiente de alta qualidade", "Cosmética profissional", "Tempo para as suas necessidades"],
    servicesNo: "02",
    servicesEyebrow: "Tratamentos",
    servicesTitle: "O que você gostaria de colocar hoje no centro?",
    servicesIntro: "Massagem, cosmética e styling – cada tratamento adaptado individualmente a você.",
    auszeitNo: "03",
    auszeitEyebrow: "Sua pausa",
    auszeitTitle: "Sua pausa começa no momento em que você escolhe a si mesma.",
    auszeitText: "Deixe a rotina para trás por um momento. Sinta calma, cuidado e energia renovada – tudo pensado para você.",
    ablaufEyebrow: "Como funciona",
    ablaufTitle: "É assim tão simples começar o seu momento Imperium",
    steps: [
      { t: "Escolher o tratamento", d: "Você descobre o que te faz bem hoje." },
      { t: "Entrar em contato", d: "Bem simples: por formulário, WhatsApp ou ligação." },
      { t: "Ser atendida pessoalmente", d: "Tudo é adaptado a você e aos seus desejos." },
      { t: "Chegar relaxada", d: "Você entra e a rotina fica do lado de fora." },
      { t: "Aproveitar o tratamento", d: "Seu momento Imperium – só para você." },
    ],
    expertNo: "04",
    expertEyebrow: "Sua especialista",
    expertName: "Leidiane Alcântara",
    expertText: "Profissional de estética e bem-estar – com dedicação, aperfeiçoamento contínuo e um olhar atento às necessidades individuais de cada pessoa.",
    studioNo: "05",
    studioEyebrow: "O estúdio",
    studioTitle: "Um espaço que nasce com carinho em cada detalhe.",
    studioText: "Na Basileia está nascendo a IMPERIUM Beauty & Wellness – um estúdio moderno, elegante e confortável, criado para uma experiência completa de beleza, cuidado e bem-estar.",
    galleryEyebrow: "Galeria",
    galleryTitle: "Vislumbres do universo IMPERIUM",
    finalTitle: "Pronta para a sua pausa mais bonita?",
    finalText: "Reserve um tempo para você. Será um prazer te conhecer pessoalmente.",
    marquee: ["Estética", "Massagem", "Drenagem linfática", "Cuidados faciais", "Maquiagem", "Bem-estar"],
  },
  treatmentsPage: {
    eyebrow: "Tratamentos",
    title: "Seus tratamentos na IMPERIUM",
    intro: "Massagem, cosmética e styling – descubra o que te faz bem hoje. Cada tratamento é adaptado individualmente a você.",
    massage: "Massagem & Corpo",
    beauty: "Cosmética & Styling",
  },
  treatment: {
    back: "Todos os tratamentos",
    related: "Outros tratamentos",
    ctaTitle: "Solicitar este tratamento",
    ctaText: "Me conte seus desejos – eu te atendo pessoalmente e juntas encontramos o seu momento Imperium.",
  },
  about: {
    eyebrow: "Sobre mim",
    title: "Leidiane Alcântara",
    role: "Estética & Bem-estar",
    bio: [
      "Sou Leidiane Alcântara, profissional da área de estética e bem-estar, apaixonada por cuidar de pessoas e realçar o que existe de mais belo em cada uma delas.",
      "Com dedicação, aperfeiçoamento contínuo e um olhar atento às necessidades individuais, construí minha trajetória com muito trabalho, responsabilidade e amor pelo que faço.",
      "Acredito que cada pessoa é única, e por isso ofereço um atendimento personalizado, com técnicas modernas e seguras, sempre priorizando o cuidado, a estética e o bem-estar.",
    ],
    storyEyebrow: "A história",
    storyTitle: "O sonho da IMPERIUM",
    story: [
      "Agora, estou realizando um grande sonho: estou abrindo a IMPERIUM Beauty & Wellness – um lindo estúdio criado especialmente para proporcionar uma experiência completa de beleza, cuidado e bem-estar.",
      "Cada detalhe está sendo preparado com muito carinho para que cada cliente se sinta acolhida, valorizada e viva um momento único, em um ambiente moderno, elegante e confortável.",
      "Será um espaço onde estética, relaxamento e autoestima se encontram, porque cuidar de você é a minha maior missão.",
    ],
    quote: "“Cuidar de você é a minha maior missão.”",
    philosophyEyebrow: "Filosofia",
    philosophyTitle: "Cada pessoa é única.",
    philosophyText: "Atendimento personalizado, técnicas modernas e seguras – sempre com foco no cuidado, na estética e no bem-estar.",
    ctaTitle: "Vamos nos conhecer.",
    ctaText: "Aguardo sua mensagem com alegria – pessoal, simples e sem compromisso.",
  },
  studio: {
    eyebrow: "Estúdio",
    title: "IMPERIUM na Basileia",
    intro: "Um estúdio criado para a beleza, o cuidado e o bem-estar – moderno, elegante e confortável.",
    preparing: "O estúdio está sendo preparado com muito carinho em cada detalhe. Cada cantinho nasce com o objetivo de que você se sinta bem-vinda e valorizada desde o primeiro momento.",
    locationLabel: "Localização",
    location: "Austrasse 31, 4051 Basel, Switzerland",
    ctaTitle: "Faça parte desde o início.",
    ctaText: "Escreva para mim – será um prazer te ouvir.",
  },
  contact: {
    eyebrow: "Contato",
    title: "Seu momento Imperium começa aqui.",
    intro: "Dúvida, desejo ou agendamento – escreva para mim. Respondo pessoalmente.",
    locationLabel: "Localização",
    phoneLabel: "Telefone & WhatsApp",
    emailLabel: "E-mail",
    instagramLabel: "Instagram",
    formTitle: "Enviar pedido",
  },
  form: {
    name: "Nome e sobrenome",
    email: "E-mail",
    phone: "Celular (opcional)",
    treatment: "Tratamento",
    treatmentPlaceholder: "Selecionar tratamento",
    noPreference: "Ainda não sei / Consultoria",
    message: "Mensagem",
    messagePlaceholder: "Como posso te ajudar?",
    privacy: "Li a política de privacidade e aceito o tratamento dos meus dados para responder ao meu pedido.",
    submit: "Enviar pedido",
    sending: "Enviando…",
    success: "Muito obrigada! Seu pedido chegou. Responderei pessoalmente o mais breve possível.",
    error: "Infelizmente ocorreu um erro. Tente novamente ou me escreva pelo WhatsApp.",
    required: "Preencha todos os campos obrigatórios.",
    invalidEmail: "Digite um endereço de e-mail válido.",
    privacyRequired: "Confirme a política de privacidade.",
  },
  footer: {
    tagline: "Estética · Massagem · Bem-estar",
    navTitle: "Navegação",
    treatmentsTitle: "Tratamentos",
    contactTitle: "Contato",
    legalTitle: "Informações legais",
    impressum: "Impressum",
    privacy: "Privacidade",
    rights: "Todos os direitos reservados.",
    location: "Austrasse 31, 4051 Basel, Switzerland",
  },
  impressum: {
    title: "Impressum",
    operatorLabel: "Responsável",
    operator: "IMPERIUM Beauty & Wellness — Leidiane Alcântara",
    contactLabel: "Contato",
    contentLabel: "Responsável pelo conteúdo",
    note: "As demais informações legais estão sendo completadas e serão adicionadas em breve.",
  },
  privacyPage: {
    title: "Política de privacidade",
    responsibleTitle: "Responsável",
    responsibleText: "IMPERIUM Beauty & Wellness — Leidiane Alcântara, Austrasse 31, 4051 Basel, Switzerland.",
    dataTitle: "Dados do formulário de contato",
    dataText: "Quando você me escreve pelo formulário, seus dados (nome, e-mail, telefone, mensagem) são usados exclusivamente para responder ao seu pedido e não são compartilhados com terceiros.",
    storageTitle: "Armazenamento no navegador",
    storageText: "Este site salva apenas a sua escolha de idioma e a sua decisão sobre cookies localmente no seu navegador. Não são usados cookies de rastreamento.",
    rightsTitle: "Seus direitos",
    rightsText: "Você tem sempre o direito de acessar, corrigir ou excluir seus dados. Basta escrever para kontakt@imperium-wellness.ch.",
  },
  google: { label: "IMPERIUM no Google", rate: "Avaliar no Google", reviews: "Ver avaliações" },
  notfound: {
    title: "404",
    heading: "Esta página não foi encontrada.",
    text: "Talvez você encontre aqui o que procura:",
  },
  cookie: {
    text: "Este site usa apenas armazenamento tecnicamente necessário – por exemplo, para a sua escolha de idioma. Não são definidos cookies de rastreamento.",
    accept: "Entendi",
    more: "Privacidade",
  },
  seo: {
    homeTitle: "IMPERIUM Beauty & Wellness | Cosmética, Estética e Massagens na Basileia",
    homeDesc: "Cosmética profissional e massagens relaxantes para mais luminosidade, calma e bem-estar. Sua beleza. Seu momento. Seu Imperium.",
  },
};
